import { Box, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import {
  Labeled,
  LabeledProps,
  TextInput,
  TextInputProps,
  useGetMany,
  useSimpleFormIteratorItem,
} from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { Item } from '../../types';

export const LinesTypeField = (props: Omit<TextInputProps, 'children'>) => {
  const iterator = useSimpleFormIteratorItem();
  const { setValue } = useFormContext();

  const itemId = useWatch<Item>({ name: `lines.${iterator.index}.item` });
  const { data, isLoading } = useGetMany<Item>(
    'items',
    {
      ids: [itemId],
    },
    { enabled: !!itemId }
  );

  useEffect(() => {
    // Only write the type once the items lookup has actually resolved. This
    // effect used to fire on the unresolved render too, persisting the literal
    // '_' — and since the form submits the whole `lines` array, that save also
    // overwrote lines written elsewhere (the family's death-certificate
    // selection from the Aura checkout flow), silently dropping paid-for items.
    if (!itemId || isLoading || !data?.[0]) {
      return;
    }
    setValue(`lines.${iterator.index}.type`, data[0]?.ParentRef?.name ?? '_');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, data, isLoading]);
    return <TextInput
      hidden 
      type="hidden"
      label={false} 
      InputProps={{ disableUnderline: true }}
      helperText={false}
      sx={{display: 'none'}}
      {...props} 
    />;

};
